var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.06,
    height: 66.083,
    viewBox: "0 0 48.06 66.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Payments-received",
    d: "M43.37,11.262a1.69,1.69,0,0,0,1.69-1.69V3.94a1.69,1.69,0,0,0-1.69-1.69H1.69A1.69,1.69,0,0,0,0,3.94v6.3a1.69,1.69,0,0,0,1.69,1.69H13.7c3.845,0,6.8,1.4,8.585,3.837H1.69A1.69,1.69,0,0,0,0,17.458V23.09a1.69,1.69,0,0,0,1.69,1.69H24.044c-.875,5.081-4.641,8.256-10.527,8.256H1.69A1.69,1.69,0,0,0,0,34.726V42.19a1.69,1.69,0,0,0,.544,1.242L23.785,64.885a1.69,1.69,0,0,0,1.146.448H36.557A1.69,1.69,0,0,0,37.7,62.4L16.457,42.79c10.772-.33,18.467-7.519,19.477-18.011H43.37a1.69,1.69,0,0,0,1.69-1.69V17.458a1.69,1.69,0,0,0-1.69-1.69H35.106A19.288,19.288,0,0,0,33.1,11.262Z",
    transform: "translate(1.5 -0.75)",
    fill: "none",
    stroke: "#50c878",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsReceived);
export default __webpack_public_path__ + "static/media/Payments-received.43b3e896a8d9bc51a5948a80b05c1d03.svg";
export { ForwardRef as ReactComponent };